module.exports = __webpack_public_path__ + "static/media/question.015700d4.png";